export enum WesterosPwmProfileModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
